import { useToast } from "@familyzone/component-library";

/**
 * Helper to allow using React hooks in class component.
 *
 * @deprecated New views should all be implemented as functional components, and
 * it's strongly advised to convert existing views into a functional component
 * where hooks can be used directly.
 */
export function withToast(WrappedComponent) {
  return function WithToast(props) {
    const { errorToast } = useToast();
    return <WrappedComponent {...props} errorToast={errorToast} />;
  };
}
